let pageteaser = {

    init: () =>{

        pageteaser.name = '.ce_rsce_pageteaser';
        pageteaser.elements = document.querySelectorAll(pageteaser.name);
        pageteaser.attemptActionIfNotEmpty(pageteaser.ready);

        window.addEventListener('load', () => {
            pageteaser.attemptActionIfNotEmpty(pageteaser.loaded);
        });

        return pageteaser;
    },

    attemptActionIfNotEmpty: function (action) {
        if (pageteaser.elements.length > 0) {
            action();
        }
    },

    ready : () => {

        const teasertexts = document.querySelectorAll('.teaser__card-text');
        teasertexts.forEach((text) => {
            let limitedText = limitWords(text.textContent.trim());
            text.textContent = limitedText;
        });

        function limitWords(text) {
            const words = text.split(' ');
            if (words.length > 20) {
                return words.slice(0, 20).join(' ') + '...';
            } else {
                return text;
            }
        }

    },

    loaded : () => {

    }

};

export default pageteaser.init();
